import { AbstractProvider } from './AbstractProvider';
import { get, set, has, merge } from 'lodash';

export class MemoryProvider extends AbstractProvider {

  data = {};

  get userData() { return this.data[this.userId]; }
  set userData( val ) { this.data[this.userId] = val; }

  constructor(userId) {
    super(userId);
  }

  async get(key, defaultValue = null) {
    return this.getSync(key, defaultValue);
  }

  getSync(key, defaultValue) {
    return get(this.userData, this.generateKey(key), super.get(key, defaultValue));
  }

  async patch(key, value) {
    set(this.userData, this.generateKey(key), value);
    return true;
  }

  async patchObject(object = {}) {
    this.userData = merge(this.userData, object);
    return true;
  }

  has(key) {
    return has(this.userData, this.generateKey(key));
  }

  generateKey(key) {
    return key;
  }
}
